/*
  The one message the server sends when two writes collided (ERROR_CONCURRENCY_001/002), held in
  a store of its own.

  It is deliberately NOT a Swal. Swal is a singleton that the rest of the app fires and closes
  freely -- onSettled: Swal.close(), a success toast after a mutate() that resolved undefined on
  failure -- and any of those would take this message off screen. Nothing else writes here, so
  only the user's own confirm removes it. <ConcurrencyAlert /> renders it.
*/
let current = null;
const listeners = new Set();

const publish = (next) => {
  current = next;
  listeners.forEach((listener) => listener());
};

export const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** A new object per show, and the same one between changes, as useSyncExternalStore requires. */
export const getSnapshot = () => current;

/**
 * tone: "warning" (409, check before retrying) or "info" (503, nothing was saved).
 *
 * A 409 still on screen is never replaced by a 503: "check before trying again" is the one the
 * user has to act on, and "nothing was saved" over it would invite the blind resend it warns
 * against. A newer 409, or a 409 over a 503, does replace it.
 */
export const showConcurrencyAlert = (message, tone = "warning") => {
  if (current?.tone === "warning" && tone !== "warning") return;
  publish({ message, tone });
};

export const dismissConcurrencyAlert = () => {
  if (current !== null) publish(null);
};
